export class Search {
  UserToken: String;
  SearchKey: String = '';
  Date_From: String;
  Date_To: String;
  Pagination: Number = 10;
  Page: Number = 1;
  Id_Supplier: Number;
  Status: String;
  Type: String;
  Seen: Boolean;
}

export class UserSelected {
  Id_User: Number;
    Id_Customer: Number;
    Id_Company: Number;
    Id_Language: Number;
    Status: String;
    StatusName: String;
    Name: String;
    Img_Path: String;
    Email: String;
    Date_Add: String;
    Password: String;
    CustomerName: String;
    CompanyName: String;
    UserType: String;
}



// WEBPACK FOOTER //
// ./src/app/shared/notifications.ts